import { useEffect } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { WhyUs } from "../components/WhyUs";
import { Portfolio } from "../components/Portfolio";
import { ConversionCTA } from "../components/ConversionCTA";
import { QuoteForm } from "../components/QuoteForm";
import { About } from "../components/About";
import { FAQ } from "../components/FAQ";
import { Footer } from "../components/Footer";
import { scrollToId } from "../lib/site";

export default function Home() {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyUs />
        <Portfolio />
        <ConversionCTA />
        <QuoteForm />
        <About />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
